import {
  Box,
  Button,
  FormControl,
  Icon,
  IconButton,
  Skeleton,
  Tabs,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useContext, useState } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { useTranslation } from "react-i18next";
import TabPanel from "../../../TabPanel";
import { useSelector } from "react-redux";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import LightTooltip from "../../../../commonComponents/LightTooltip";

const options = {
  lineNumbers: true,
  lineWrapping: true, // Enable text wrap
};

const DatabaseNavigatorRightTop = ({
  showQuery,
  sqlQuery,
  setSqlQuery,
  setSqlActions,
  templateQuery,
  selectedTable,
  currTab,
  setCurrTab,
  setCurrTabBottom,
}) => {
  const { t } = useTranslation();
  const handleTabChange = (e, newValue) => {
    setCurrTab(newValue);
  };
  const parentScreen = useContext(ParentScreenCtx);
  const connectionLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["SCHEMA_LOADING"]?.isLoading || false) // Commenting this for now
  const connectionError = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["SCHEMA_LOADING"]?.isError || false) // Commenting this for now
  const tableLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.['TABLE_LOADING']?.isLoading || false);
  const metaLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["META_LOADING"]?.isLoading || false) 
  const top25Loading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["TOP25_LOADING"]?.isLoading || false) 
  const sqlLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["SQL_LOADING"]?.isLoading || false) 
  const compareLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["COMPARE_LOADING"]?.isLoading || false) 

  const runSqlScriptHandler = () => {
    setSqlActions((prev) => {
      return {runSqlScript: true };
    });
  };

  const runTemplateScriptHandler = () => {
    setSqlActions((prev) => {
      return {runTemplateScript: true };
    });
  };

  const runCompareSql = () =>{
    setSqlActions((prev) => {
      return {compareSql : true};
    })
  }

  return (
    <div className="flex-column height-100 ">
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs onChange={handleTabChange} value={currTab}>
            <Tab
              disabled={connectionLoading || tableLoading || metaLoading || top25Loading || sqlLoading || compareLoading || !showQuery}
              label={
                <div className="flex align-center" style={{ gap: "6px" }}>
                  <span className="flex align-center">
                    <span className="BALLOT screen-tab-icons"></span>
                    {t("DB_NAV_TAB_SQL_TEMPLATE")}
                  </span>
                  <LightTooltip
                    title={t("DB_NAV_RUN_SQL")}
                    className="flex align-center"
                    onClick={(e) => {
                      e.preventDefault();
                      runTemplateScriptHandler();
                      setCurrTabBottom(2);
                    }}
                  >
                    <Icon>
                      <div className="FLASH_ON screen-tab-icons flex align-center"></div>
                    </Icon>
                  </LightTooltip>
                </div>
              }
            />

            <Tab
              disabled={connectionLoading || tableLoading || metaLoading || top25Loading || sqlLoading || compareLoading || !showQuery}
              label={
                <div className="flex align-center" style={{ gap: "6px" }}>
                  <span className="flex align-center">
                    <span className="NOTE_ALT screen-tab-icons"></span>
                    {t("DB_NAV_TAB_SQL_SCRIPT")}
                  </span>
                  <Box className="flex align-center" style={{ gap: "4px" }}>
                    <LightTooltip
                      title={t("DB_NAV_UPDATE_TEMPLATE_FROM_SQL")}
                      className="flex align-center"
                      onClick={(e) => {
                        e.preventDefault();
                        runCompareSql();
                      }}
                    >
                      <Icon>
                        <div className="ADD screen-tab-icons flex align-center"></div>
                      </Icon>
                    </LightTooltip>
                    <LightTooltip
                      title={t("DB_NAV_RUN_SQL")}
                      className="flex align-center"
                      onClick={(e) => {
                        e.preventDefault(true);
                        runSqlScriptHandler();
                        setCurrTabBottom(2);
                      }}
                    >
                      <Icon>
                        <div className="FLASH_ON"></div>
                      </Icon>
                    </LightTooltip>
                  </Box>
                </div>
              }
            />
          </Tabs>
        </Box>
        {currTab === 0 && (
          <TabPanel
            value={currTab}
            index={0}
            className="height-100 overflow-auto"
            // style={{ backgroundColor: "rgb(238, 238, 238)" }}
          >
            {showQuery ? <div className="height-100 overflow-auto">
              <TextField
                contentEditable={false}
                multiline={true}
                minRows={10}
                value={templateQuery}
                spellCheck={false}
                className="font-14"
                sx={{
                  "& fieldset": { border: "none" },
                  width: "100%",
                  height: "100%",
                  outline: "none",
                  border: "none",
                }}
                inputProps={{
                  className: "font-14",
                }}
                fullWidth
              />
            </div> : <div className="height-100 overflow-auto" style={{padding: '5px'}}>
              <Skeleton width={"70%"} />
              <Skeleton width={"50%"} />
              <Skeleton width={"65%"} />
              <Skeleton width={"60%"}/>
              <Skeleton width={"85%"}/>
              <Skeleton />
              <Skeleton />
            </div> }
          </TabPanel>
        )}
        {currTab === 1 && (
          <TabPanel
            value={currTab}
            index={1}
            className={"height-100 overflow-auto"}
          >
            {showQuery ? <div className="height-100 overflow-auto">
              <TextField
                autoFocus
                multiline={true}
                minRows={10}
                value={sqlQuery}
                spellCheck={false}
                className="font-14"
                sx={{
                  "& fieldset": { border: "none" },
                  width: "100%",
                  height: "100%",
                  outline: "none",
                  border: "none",
                }}
                inputProps={{
                  class: "font-14",
                  style: { color: "blue" },
                }}
                fullWidth
                onChange={(e) => {
                  setSqlQuery(e.target.value);
                }}
              />
            </div> : <div className="height-100 overflow-auto" style={{padding: '5px'}}>
              <Skeleton width={"70%"} />
              <Skeleton width={"50%"} />
              <Skeleton width={"65%"} />
              <Skeleton width={"60%"}/>
              <Skeleton width={"85%"}/>
              <Skeleton />
              <Skeleton />
            </div> }
          </TabPanel>
        )}
    </div>
  );
};

export default DatabaseNavigatorRightTop;
